var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBookmarksIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3703_7761)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0625 0H6.1875C5.68866 0.00041151 5.20405 0.166303 4.8096 0.47168C4.41516 0.777058 4.13316 1.20466 4.00781 1.6875H12.0234C12.7134 1.6875 13.3751 1.96159 13.863 2.44948C14.3509 2.93737 14.625 3.59909 14.625 4.28906V15.0079L15.3984 15.6266C15.4943 15.7034 15.6127 15.7466 15.7354 15.7498C15.8582 15.753 15.9786 15.7159 16.0784 15.6442C16.152 15.5898 16.2117 15.5186 16.2524 15.4366C16.2931 15.3545 16.3137 15.264 16.3125 15.1724V2.25C16.3125 1.65326 16.0754 1.08097 15.6535 0.65901C15.2315 0.237053 14.6592 0 14.0625 0V0Z",
    fill: "#CA5050"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2501 2.8125H3.93757C3.34083 2.8125 2.76853 3.04955 2.34658 3.47151C1.92462 3.89347 1.68757 4.46576 1.68757 5.0625V17.4241C1.68618 17.5153 1.7065 17.6055 1.74684 17.6873C1.78718 17.7691 1.8464 17.8401 1.9196 17.8945C2.02129 17.9684 2.14478 18.006 2.27037 18.0015C2.39596 17.997 2.51642 17.9505 2.61253 17.8696L7.59382 13.673L12.5751 17.8678C12.6706 17.9483 12.7901 17.9946 12.9149 17.9997C13.0396 18.0047 13.1625 17.9681 13.2642 17.8956C13.3383 17.8413 13.3984 17.7701 13.4394 17.6879C13.4804 17.6057 13.5012 17.5149 13.5001 17.4231V5.0625C13.5001 4.46576 13.263 3.89347 12.8411 3.47151C12.4191 3.04955 11.8468 2.8125 11.2501 2.8125Z",
    fill: "#CA5050"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3703_7761"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarksIcon);
export default __webpack_public_path__ + "static/media/bookmarks-icon.4ee855c3013e8e7d9d1ecd6fb01dbdab.svg";
export { ForwardRef as ReactComponent };